import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { ServiceApiProvider } from '../../providers/service-api/service-api';
import { B08ReportManagementPage } from '../b08-report-management/b08-report-management';
import { ServiceGvariableProvider } from '../../providers/service-gvariable/service-gvariable';
/**
 * Generated class for the B08eInvoiceSummaryPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

interface branchInfo{
  BRANCH_ID: string;
  BRANCH_NAME: string;
  BRANCH_ACTIVE: string;  
}
interface itemInfo{
  INVENTORY_ID: string;
  INVENTORY_NAME: string;
  INVENTORY_ACTIVE: string;  
}
interface reportInfo{}
@IonicPage()
@Component({
  selector: 'page-b08l-good-receive',
  templateUrl: 'b08l-good-receive.html',
})
export class B08lGoodReceivePage {

  private todo : FormGroup;
  loading: any;
  Status: any;
  branchArr: branchInfo[] = [];
  branchItems: branchInfo[] = [];
  itemArr: itemInfo[] = [];
  itemItems: itemInfo[] = [];
  reportItems: reportInfo[] = [];
  public errorMessage: any = "";
  BRANCH_ID: any = 'All';
  ITEM_ID: any = 'All';
  invDateFrom: any;
  invDateTo: any;
  transDateFrom: any;
  transDateTo: any;
  plateNumber: any;
  filename:any;
  selectCORP_ID:any;
  report_request = {
    Report: "12",
    Param: "1",
    Data:{
      BRANCH_ID: "All",
      START: "",
      END: "",
      ITEM_ID: "All",
      PO_NO: "",
      SORT: "BRANCH_NAME",
      SORT_TYPE: "ASC"
    }
  }

  onSelectBranch(data)
  {
   if(data != "All")
   {
    let val = this.branchItems.find(c => c.BRANCH_ID === data);
    this.report_request.Data.BRANCH_ID = val["BRANCH_ID"];
    let tbl = ["INVENTORY"];
    let column = ["BRANCH_ID"];
    let value = [val["BRANCH_ID"]];
    
    let tblkey = ["No"];
    let fktbl = ["No"];
    let fkkey = ["No"];

    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

    let mydata = Object.assign(jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
  

    this.serviceapi.readdata(json_data,"INVENTORY","1","1").then((result) => {
    
      this.Status = result["Message"];
      if (this.Status == '1'){
        
        let Records = result["Records"];
        this.itemArr = Records;
        this.itemItems = this.itemArr;
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
      }
    }, (err) => {
      this.errorMessage = "Loading Error. Please try again.";
    
    });
   }
   else
   {
    this.report_request.Data.BRANCH_ID ="All";
   }
  }  
  onSelectItem(data)
  {
   if(data != "All")
   {
    let val = this.itemItems.find(c => c.INVENTORY_ID === data);
    this.report_request.Data.ITEM_ID = val["ITEM_DESC"];  // [CXY:09/09/2020:IL/MB/20-03]:Modify INVENTORY_ID TO ITEM_DESC
   }
   else
   {
    this.report_request.Data.ITEM_ID ="All";
   }
  }  
  mybranchid:any;
  mybranchname:any;
  constructor(public navCtrl: NavController, public navParams: NavParams,
              private formBuilder: FormBuilder, public serviceapi:ServiceApiProvider,
              public loadingCtrl: LoadingController, public global:ServiceGvariableProvider) {

    
    this.mybranchid = sessionStorage.getItem('userbranchid');
                
    //this.mybranchname = sessionStorage.getItem('userbranchname');
    if(this.mybranchid == 'null')
    {
      this.todo = this.formBuilder.group({
        branch: ['', Validators.required],
        item: ['', Validators.required],
        poNum: [''],
        invDateFrom: [''],
        invDateTo: [''],
      });
    }
    else
    {
      this.todo = this.formBuilder.group({
        branch: [''],
        item: ['', Validators.required],
        poNum: [''],
        invDateFrom: [''],
        invDateTo: [''],
      });
      this.report_request.Data.BRANCH_ID = this.mybranchid;
      let tbl = ["BRANCH"];
      let column = ["BRANCH_ID"];
      let value = [this.mybranchid];
      
      let tblkey = ["No"];
      let fktbl = ["No"];
      let fkkey = ["No"];

      let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

      let mydata = Object.assign(jsonitem);
      let json_data = this.serviceapi.json_readdata(mydata,"1");
      

      this.serviceapi.readdata(json_data,"BRANCH","1","1").then((result) => {
        
        this.Status = result["Message"];
      
        if (this.Status == '1'){
          let Records = result["Records"];
          this.mybranchname = Records[0]["BRANCH_NAME"];
        }
        else {
         
        }
      }, (err) => {
       
      
      });

    }
    let tbl = ["All"];
    let column = ["All"];
    let value = ["All"];
    
    let tblkey = ["No"];
    let fktbl = ["No"];
    let fkkey = ["No"];

    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

    let mydata = Object.assign(jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
    this.showLoader();

    this.serviceapi.readdata(json_data,"BRANCH","1","1").then((result) => {
      
      this.Status = result["Message"];
      if (this.Status == '1'){
        
        let Records = result["Records"];
        this.branchArr = Records;
        this.branchItems = this.branchArr;
        let tbl = ["All"];
        let column = ["All"];
        let value = ["All"];
        
        let tblkey = ["No"];
        let fktbl = ["No"];
        let fkkey = ["No"];

        let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

        let mydata = Object.assign(jsonitem);
        let json_data = this.serviceapi.json_readdata(mydata,"1");
       
        this.serviceapi.readdata(json_data,"INVENTORY","1","1").then((result) => {
          this.loading.dismiss();
          this.Status = result["Message"];
          if (this.Status == '1'){
            
            let Records = result["Records"];
            this.itemArr = Records;
            this.itemItems = this.itemArr;
          }
          else {
            this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
          }
        }, (err) => {
          this.errorMessage = "Loading Error. Please try again.";
          this.loading.dismiss();
        });
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
      }
    }, (err) => {
      this.errorMessage = "Loading Error. Please try again.";
      this.loading.dismiss();
    });

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad B08eInvoiceSummaryPage');
  }

  showLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000
    });

    this.loading.present();
  }

  onChangeCorp(data){
    this.BRANCH_ID = data;
  }

  goTo(){
    this.navCtrl.setRoot(B08ReportManagementPage);
  }

  generate(){
    console.log(this.report_request);
    this.showLoader();

    this.serviceapi.reportrequest(this.report_request).then((result) => {
      this.loading.dismiss();
      this.Status = result["Message"];
      console.log(this.Status);
      if (this.Status == '1'){
        
        let Records = result["Records"];
        this.reportItems = Records;
        console.log(this.reportItems)
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
      }
    }, (err) => {
      this.errorMessage = "Loading Error. Please try again.";
      this.loading.dismiss();
    });
  }

  download(){
    this.showLoader();
    this.report_request.Param = "2";
    this.serviceapi.reportrequest(this.report_request).then((result) => {
      this.loading.dismiss();
      this.Status = result["Message"];
      if (this.Status == '1'){
        
        let Records = result["Records"];
        this.reportItems = Records;
        let file = result["File"];
        let path = file.replace('..','');
        let url = this.global.URL+"/api";
        var remove = path.substring(0, path.lastIndexOf("/"));
        console.log(remove);
        var splitTest = file.split('\\').pop().split('/').pop();
        this.filename=url+remove+"/"+splitTest;
        console.log(this.filename);
        window.open(this.filename,"_blank");
        console.log(this.reportItems)
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
      }
    }, (err) => {
      this.errorMessage = "Loading Error. Please try again.";
      this.loading.dismiss();
    });
  }

  cancel(){
    this.navCtrl.pop();
  }

  clearFilter(){
    this.BRANCH_ID = 'All';
    this.ITEM_ID = 'All';
    this.report_request.Data.START = '';
    this.report_request.Data.END = '';
  }
}


// WEBPACK FOOTER //
// ./src/pages/b08l-good-receive/b08l-good-receive.ts